import React, { useState } from 'react';
import { withTranslation } from '../../lib/translate';
import { Title, Spacer, Sectiontitle, StrongText, Subtitle, NormalText } from '../../components/common';
import Basket from '../../lib/basket';
import './index.css';
import { connect } from 'react-redux';
import { deepCopy, getLocale } from '../../lib/utils';
import { chevronDown, chevronUp } from 'ionicons/icons';
import { IonButton, IonIcon } from '@ionic/react';
import { setCommonProp } from '../../store/actions';
const { getItems, getAllergen } = Basket;



const AllergenCard = ({ name, items, __ }) => {
  const [opened, openCard] = useState(false)
  return (
    <div className='allergen-wrapper'>
      <div className='allergen-header' onClick={() => openCard(!opened)}>
        <Subtitle>{name}</Subtitle>
        <IonIcon icon={opened ? chevronUp : chevronDown} />

      </div>
      {opened &&
        <div className='allergen-content'>
          <NormalText>{__('Present in:')}</NormalText>
          <Spacer size={1} />
          {items.map(el => (
            <div>
              <img src={el?.image} />
              <NormalText className='label-color'>{el?.name}</NormalText>
            </div>
          ))}

        </div>

      }
    </div>
  )
}
class ApplyAllergensRaw extends React.Component {
  formatAllergens = (data, basketData) => {


    const { allergens } = this.props
    const locale = getLocale()
    const translation = allergens.reduce((acc, item) => {
      acc[item.code] = item.translations.find(el => el.locale == locale)?.text ?? item.code;
      return acc;
    }, {});
    const flattened = data.flatMap(([a, s]) =>
      a.allergens.map(allergen => ({
        allergen,
        sku: s.sku
      }))
    );


    const groupedMap = new Map();

    for (const { allergen, sku } of flattened) {
      if (!groupedMap.has(allergen)) {
        groupedMap.set(allergen, new Set());
      }
      groupedMap.get(allergen).add(sku);
    }

    return Array.from(groupedMap.entries()).map(([allergen, skuSet]) => ({
      name: translation[allergen] ?? allergen,
      items: Array.from(skuSet).map(el => basketData[el])
    }));

  }
  render() {
    const { __ } = this.props;
    const allergensData = getAllergen() || [];
    const basketItems = Basket.has_multi_basket ? deepCopy(Basket.multi_basket_items.flatMap(el=>el.items.flat())) :deepCopy(getItems())
    const basketData = {}
    for (let i = 0; i < basketItems.length; i++) {
      if (basketItems[i].item?.itemRichData?.allergenCodes) {
        basketData[`${basketItems[i].item.sku}`] = {
          name: Basket.getProductName(basketItems[i].item),
          image: basketItems[i].item?.itemRichData?.squareImageUrl
        }

      }
      const subItems = basketItems[i]?.selectedChoices?.flat()
      for (let j = 0; j < subItems.length; j++) {
        if (subItems[j]?.itemRichData?.allergenCodes) {
          basketData[`${subItems[j].sku}`] = {
            name: Basket.getProductName(subItems[j]),
            image: subItems[j]?.itemRichData?.squareImageUrl ?? basketItems[i].item?.itemRichData?.squareImageUrl
          }
        }
      }

    }
    const allergens = this.formatAllergens(allergensData, basketData)

    return (
      <div style={{ flex: '1', overflow: 'auto', width: '100%' }}>
        <div className="allergens-wrapper ">
          {allergens.map(el => (
            <AllergenCard name={el.name} items={el.items} __={__} />
          ))}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (store) => {
  return {
    allergens: store.restaurants.allergens.data || [],
  };
};
export const ApplyAllergens = connect(mapStateToProps)(withTranslation(ApplyAllergensRaw));

const AllergensWrapped = (props) => (
  <ApplyAllergens {...props} />
);

export default withTranslation(AllergensWrapped);
